import { ComponentType } from 'react';
import lift from '@tcc/load-lifter';

type importFromS3Signature = (
  moduleName: string
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Promise<{ default: ComponentType<any> }>;

export const importFromS3: importFromS3Signature = (moduleName) =>
  new Promise((resolve) => lift([moduleName], (module) => resolve(module)));
